import { ISettings } from "@admin/pages/settings-manager/interfaces/settings.interface";
import { Component, Input, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { NewsletterDialogComponent } from "@core/newletter-dialog/newsletter-dialog.component";
import { SearchCertificateDialogComponent } from "@core/search-certificate-dialog/search-certificate-dialog.component";
import { ModalUtilsService } from "@core/services/modal-utils.service";
import {
  faCcAmex,
  faCcApplePay,
  faCcMastercard,
  faCcPaypal,
  faCcVisa,
  faFacebookF,
  faGooglePay,
  faInstagram,
  faLinkedinIn,
  faTiktok,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { LanguageService } from "@shared/services/language.service";
import { PublicGenericService } from "@shared/services/public-generic.service";
import { Group } from "../../../pages-manager/interfaces/pages.interface";
import { PagesService } from "../../../pages-manager/services/pages.service";

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [
    FontAwesomeModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
@UntilDestroy()
export class FooterComponent implements OnInit {
  faInstagram = faInstagram;
  faFacebookF = faFacebookF;
  faTikTok = faTiktok;
  faTwitter = faTwitter;
  faLinkedinIn = faLinkedinIn;
  faCcPaypal = faCcPaypal;
  faCcVisa = faCcVisa;
  faCcMastercard = faCcMastercard;
  faCcAmex = faCcAmex;
  faCcApplePay = faCcApplePay;
  faGooglePay = faGooglePay;

  pagesList: Array<Group> = [];
  pagesCol1: Array<Group>;
  pagesCol2: Array<Group>;

  currLang: string = null;

  email: string;

  @Input() appSettings: ISettings;
  @Input() showAll: boolean = true;

  constructor(
    private pagesService: PagesService,
    public publicGenericService: PublicGenericService,
    private modalUtils: ModalUtilsService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    if (this.showAll) {
      this.pagesService
        .getGroups()
        .pipe(untilDestroyed(this))
        .subscribe((dataR) => {
          this.languageService.selectedLanguage$.subscribe((lang) => {
            this.currLang = lang.code;
            this.pagesList = dataR.map((group) => ({
              ...group,
              pageGroupList: group.pageGroupList.map((x) => ({
                ...x,
                languagePath:
                  lang.code +
                  "/" +
                  x.pageRoute,
              })),
            })) as any;

            this.pagesCol1 =
              this.pagesList?.filter((x) => x.colNumber === 1) ?? [];
            this.pagesCol2 =
              this.pagesList?.filter((x) => x.colNumber !== 1) ?? [];
          });
        });
    }
  }

  // goToPage(route: string) {
  //   this.router.navigate([route]);
  // }

  onSubmit(form: NgForm) {
    const ref = this.modalUtils.openModal(NewsletterDialogComponent, {
      size: "lg",
      keyboard: false,
    });
    ref.componentInstance.email = this.email;
  }

  certificateDialog() {
    this.modalUtils.openModal(SearchCertificateDialogComponent, {
      size: "lg",
      keyboard: false,
    });
  }
}
